import React from 'react';
import Couriers from '../../components/organisms/Couriers/Couriers';

const ConfirmList = () => {
    return <Couriers url="/courier/pending-list" route="confirm" />;
};

export default ConfirmList;
